import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {VoteModel} from "../models/vote.model";
import {Observable} from "rxjs";
import {VoteOptionsModel} from "../models/vote-options.model";
import {map, shareReplay, tap} from "rxjs/operators";
import {CandidateType, CandidateTypes} from "../types";
import {AuthService} from "./auth.service";

const findOptions = (options: VoteOptionsModel[], type: CandidateType): VoteOptionsModel => {
  return options.find(option => option.candidateType === type)!;
}

const getOption = (type: CandidateType) => {
  return map((options: VoteOptionsModel[]) => findOptions(options, type));
}

@Injectable({
  providedIn: 'root'
})
export class VotingService {
  public count = 0;
  private readonly _apiUrl = environment.apiUrl + 'api/';
  private readonly _options$ = this._getVoteOptions().pipe(shareReplay(1));
  readonly senateOptions$ = this._options$.pipe(getOption(CandidateTypes.SENATE));
  readonly councilOptions$ = this._options$.pipe(getOption(CandidateTypes.COUNCIL));


  constructor(
    private readonly _http: HttpClient,
    private readonly _authService: AuthService
  ) { }

  vote(votes: VoteModel[]): Observable<string> {
    const url = this._apiUrl + 'vote';

    return this._http.post(url, votes,
      {headers: this._authService.getHeaders(true), responseType: 'text'});
  }

  private _getVoteOptions(): Observable<VoteOptionsModel[]> {
    const url = this._apiUrl + 'vote';

    return this
      ._http.get<{ candidates: VoteOptionsModel[] }>(url, this._authService.getOptions(true))
      .pipe(tap(options => {
        options.candidates.forEach(c => {
          this.count += c.candidates.length;
        });
      }), map(options => options.candidates));
  }
}
